










































































import { FindingType } from "@/common/api/findings/findings.model";
import { POPULATION_TYPE } from "@/common/models";
import { SharedState } from "@/common/state";
import PremiumModalVue from "@/components/premium/PremiumModal.vue";
import { UseModal } from "@/components/root/modal";
import ThemeImg from "@/components/ThemeImg.vue";
import { ApplicationType } from "@/views/customize/data-sources/data/model";
import SelectSessionBtn from "@/views/customize/data-sources/modals/source-details/SelectSessionBtn.vue";
import CloudScriptModalVue from "@/views/playbooks/cloud-playbooks/cloud-script-modal/CloudScriptModal.vue";
import { computed, onMounted } from "@vue/composition-api";
import Vue from "vue";
import FilesFindingsModalVue from "../../common/files-findings-modal/FilesFindingsModal.vue";
import { ModalProps } from "../../common/files-findings-modal/model";
import ContentLabelTreeModalVue from "../../common/info-types-modal/ContentLabelTreeModal.vue";
import AppCard from "./AppCard.vue";
import { state } from "./data/state";

export default Vue.extend({
  components: { AppCard, ThemeImg, SelectSessionBtn },
  setup() {
    const {
      loading,
      selected_session,
      sessions,
      set_selected_session,
      display_items,
      selected_labels,
      selected_labels_count,
      save_selected_labels_ids,
    } = state;

    const show_playbook = async (
      item: { count: number; id: string },
      application: ApplicationType
    ) => {
      const { state: playbooks_state } = await import(
        "@/views/playbooks/data/state"
      );
      const script = playbooks_state.scripts.value.find((f) => f.id == "mpip")!;
      if (script.is_not_licensed) {
        UseModal().show(PremiumModalVue, {
          key: "automatemicrosoftlabeling-popup-2024",
        });
        return;
      }

      if (SharedState.is_biz_user.value) {
        SharedState.restrictions.show_restrictions_modal("role", "Playbooks");
        return;
      }

      await UseModal().show(CloudScriptModalVue, {
        id: "mpip",
        keep_const: ["{~label}", "{~finding_type}", "{~application}"],
        application,
        session: selected_session.value,
        vars: {
          "{~application}": application,
          "{~label}": item.id,
          "{~finding_type}": "sensitive_information" as FindingType,
        },
      });
    };

    const show_files_modal = async (
      item: { count: number; id: string; name: string },
      card: { id: ApplicationType; name: string }
    ) => {
      const label = SharedState.getInfoType(item.id)!;
      if (SharedState.restrictions.is_restricted_info(label.code)) {
        SharedState.restrictions.show_restrictions_modal(
          "info",
          label.labelName
        );
        return;
      }
      await UseModal().show(FilesFindingsModalVue, {
        titles: {
          FILE: `<b>Sensitive ${item.name}</b> information files on <b>${card.name}</b>`,
        },
        tabs: [POPULATION_TYPE.FILE],
        input: {
          type: "sensitive_information",
          application: card.id,
          service: "msft_365",
          axis_z: {
            type: "Session",
            value: selected_session.value!.id,
          },
          label_ids: [item.id],
        },
      } as ModalProps);
    };

    const show_labels_modal = async () => {
      const res = await UseModal().show(ContentLabelTreeModalVue, {
        labels: selected_labels.value,
      });
      if (res.type == "success") {
        // @ts-ignore
        const selected_labels_ids = res.msg as string[];
        save_selected_labels_ids(selected_labels_ids);
      }
    };

    const open_new_session_modal = async () => {
      const { state: data_sources } = await import(
        "@/views/customize/data-sources/data/state"
      );
      const res = await data_sources.ext.open_scan_session_modal_for_source(
        "msft_365",
        selected_session.value ? selected_session.value.connectionId : ""
      );
      if (res == "refresh") {
        state.init(true);
      }
    };

    onMounted(() => {
      state.init();
    });

    return {
      loading,
      selected_session,
      sessions,
      has_at_least_one_session: computed(() => sessions.value.length > 0),
      set_selected_session,
      display_items,
      show_playbook,
      // labels
      show_labels_modal,
      selected_labels_count,
      show_files_modal,
      open_new_session_modal,
    };
  },
});
